const TrendArrowType = {
  Angled: 0,
  Parallel: 1
};

const AngledArrow = {
  0: "↑",
  1: "↗",
  2: "→",
  3: "↘",
  4: "↓",
};

const ParallelArrow = {
  0: "↑↑↑",
  1: "↑↑",
  2: "↑",
  3: "→",
  4: "↓",
  5: "↓↓",
  6: "↓↓↓"
};

export const getArrowString = (arrowType, arrowValue) => {
  return arrowType === TrendArrowType.Angled
    ? AngledArrow[arrowValue]
    : ParallelArrow[arrowValue];
};

const TrendArrowTypeName = {
  [TrendArrowType.Angled]: "FreeStyle",
  [TrendArrowType.Parallel]: "Medtronic"
};

export const getArrowTypeName = (arrowType) => {
  return TrendArrowTypeName[arrowType];
};
